export * from "ce/reducers/uiReducers/applicationsReducer";
import { default as CE_Applications_Reducer } from "ce/reducers/uiReducers/applicationsReducer";
export default CE_Applications_Reducer;
